<div class="profile-container" *ngIf="profile$ | async; let profileState">
  <form
    [formGroup]="form"
    [noValidate]="false"
    (ngSubmit)="update()"
    *ngIf="profileState.loadingState === LoadingState.SUCCESS"
  >
    <app-avatar
      (imagebase64)="getAvatar($event)"
      [avatarInput]="true"
    ></app-avatar>
    <div class="profile-block">
      <app-qs-input
        label="First Name"
        placeholder="Enter your first name"
        [controllerName]="'firstName'"
      ></app-qs-input>
      <app-qs-input
        label="Last Name"
        placeholder="Enter your last name"
        [controllerName]="'lastName'"
      ></app-qs-input>
      <app-qs-input
        label="Job Title"
        placeholder="Enter your job title"
        [controllerName]="'jobTitle'"
      ></app-qs-input>
      <app-qs-input
        label="E-mail"
        placeholder="Enter your e-mail"
        [controllerName]="'email'"
      ></app-qs-input>
    </div>
    <div class="button-container">
      <app-response-banner
        [successMessage]="'profile.form.success' | translate"
        [errorMessage]="'profile.form.error' | translate"
        [success]="successfulEdit"
        [invisible]="!showResponseBanner"
      ></app-response-banner>
      <app-button
        [disabled]="form.invalid"
        [title]="'profile.form.save' | translate"
        [matTooltip]="form.invalid ? getFormErrors().join('\n') : ''"
        [matTooltipDisabled]="form.valid"
      ></app-button>
    </div>
  </form>
</div>
